import { z } from "zod";

export const paymentStepFormSchema = z
  .object({
    paymentType: z.enum(["CREDIT_CARD", "PIX", "BOLETO"] as const, {
      required_error: "Forma de pagamento é obrigatória",
    }),
    number: z.string().optional(),
    holderName: z.string().optional(),
    expiringDate: z.string().optional(),
    ccv: z.string().optional(),
  })
  .superRefine((fields, ctx) => {
    if (fields.paymentType === "CREDIT_CARD") {
      if (!fields.number) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["number"],
          message: "Obrigatório",
        });
      }
      if (!fields.holderName) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["holderName"],
          message: "Obrigatório",
        });
      }
      if (!fields.expiringDate) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["expiringDate"],
          message: "Obrigatório",
        });
      }
      if (fields.ccv && fields.ccv.length < 3) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["ccv"],
          message: "CVV deve ter 3 dígitos",
        });
      }
      if (!fields.ccv) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["ccv"],
          message: "Obrigatório",
        });
      }
    }
  });

export type PaymentStepFormValues = z.infer<typeof paymentStepFormSchema>;
